import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_010.jpg';

page.games = [
  {
    id: 'page010_game0',
    icon: 'ikonaCwiczenie',
    color: '#FF808080',
    tooltip: 's. 10-11 (Revise)',
    pos: {
      x: LEFT,
      y: 40,
    },
    item: {
      id: 'page010_game0',
    },
  },
];

export default page;
